import { AuthService } from "services";
import { ResponseExceptionHandlerHelper, TRUSTED_DEVICE_KEY } from "utils";

export const AuthenticationManager = (() => {
  const { handleException } = ResponseExceptionHandlerHelper();

  const login = (usuario) => {
    return AuthService.login(usuario).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res.Data;
    });
  };

  const verify2fa = (params) => {
    return AuthService.verify2fa(params).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      // Si el usuario marcó "Confiar en este dispositivo", guardamos el token para
      // omitir el segundo factor en los próximos inicios de sesión.
      if (res.Data?.tokenDispositivo) {
        localStorage.setItem(TRUSTED_DEVICE_KEY, res.Data.tokenDispositivo);
      }
      return res.Data;
    });
  };

  const resend2fa = (params) => {
    return AuthService.resend2fa(params).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res.Data;
    });
  };

  const logout = () => {
    return AuthService.logout().then((res) => {
      if (!res.Success) {
        handleException(res);
      }
    });
  };

  const refreshUsuarioLogin = () => {
    return AuthService.refreshUsuarioLogin().then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res.Data;
    });
  };

  const sendRecoveryEmail = (params) => {
    return AuthService.sendRecoveryEmail(params).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res.Data;
    });
  };

  const resetPassword = (params) => {
    return AuthService.resetPassword(params).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res.Data;
    });
  };

  const listarCompaniasPermitidas = (params) => {
    return AuthService.listarCompaniasPermitidas(params).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };

  const cambiarCompania = (params) => {
    return AuthService.cambiarCompania(params).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res.Data;
    });
  };

  const volverCompaniaOriginal = () => {
    return AuthService.volverCompaniaOriginal().then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res.Data;
    });
  };

  const autenticarERPAPI = (params) => {
    return AuthService.autenticarERPAPI(params).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res.Data;
    });
  };

  return {
    login,
    verify2fa,
    resend2fa,
    logout,
    refreshUsuarioLogin,
    sendRecoveryEmail,
    resetPassword,
    cambiarCompania,
    volverCompaniaOriginal,
    listarCompaniasPermitidas,
    autenticarERPAPI
  };
})();
